import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IFindQuery } from '../Models/findQuery.model';
import { IList } from '../Models/list.model';
import { IResponse } from '../Models/response.model';
import { ISchoolArticle } from '../Models/schoolArticle.model';
import { Utils } from '../utils';
import { ApiService } from './api.service';
import { DOMAIN } from '../../configurations/defaultConfigs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SchoolApiService {
  private path = '/school';

  constructor(private apiService: ApiService, public http: HttpClient) {}

  getSchoolArticles(
    findQuery: IFindQuery
  ): Observable<IResponse<IList<ISchoolArticle>>> {
    return this.apiService.get<IResponse<IList<ISchoolArticle>>>(this.path, {
      ...findQuery,
      filter: Utils.encodeSpecialCharacters(JSON.stringify(findQuery.filter)),
    });
  }

  submitCareerApplication(
    applicationRequest: any
  ): Observable<IResponse<Boolean>> {
    const formData = new FormData();
    Object.keys(applicationRequest).forEach((key) => {
      formData.append(key, applicationRequest[key]);
    });
    return this.apiService.post(`${this.path}/career`, formData);
  }

  emailSubscribe(emailSubscribeRequest: any): Observable<IResponse<Boolean>> {
    return this.apiService.post(
      `${this.path}/emailSubscribe`,
      emailSubscribeRequest
    );
  }

  getVisitorsCount(): Observable<IResponse<number>> {
    return this.apiService.get<IResponse<number>>(
      `${this.path}/trackVisits/${DOMAIN}`
    );
  }

  trackVisits(): Observable<IResponse<Boolean>> {
    return this.apiService.post(`${this.path}/trackVisits`, {
      domainType: DOMAIN,
    });
  }

  downloadPDF(
    domainType: string,
    articleType: string,
    physicalName: string,
    originName: string
  ) {
    return this.http.get(`/api/school/downloadPDF`, {
      params: { domainType, articleType, physicalName, originName },
      responseType: 'blob' as 'json', // 👈 IMPORTANT: force blob
    });
  }
}
